import {
  getCountryCallingCode,
  isSupportedCountry,
  type CountryCode,
} from "libphonenumber-js";
import { getData, type Country } from "country-list";

export const countries = getData()
  .filter(({ code }: Country) => isSupportedCountry(code as CountryCode))
  .map(({ name, code }: Country) => ({
    name,
    code,
    dialCode: `+${getCountryCallingCode(code as CountryCode)}`,
    flag: code
      .toUpperCase()
      .replace(/./g, (c: string) =>
        String.fromCodePoint(c.charCodeAt(0) + 127397),
      ),
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
